<template>
    <div> 
		<div v-if="tradingAccountList.totalRecords > 0">
			<div v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 0 && authComponent && transaction_id != '' && !congModuleLev)">
				<app-twofa  :call_from="request_page"></app-twofa>
			</div>
			<div v-else>
				<div class="mainTitle text-center mt-4 mb-3"> 
					<h2 class="mb-3">{{$t('lev_changeLeverage')}}</h2>
					<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
					<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
				</div> 
				<!--loader - message--->
				
				<!-------------------->
				<div class="CustomBlockWidth " > 
					<div class=" row justify-content-center">
						<div class="middleBox">
							<div class="whiteBG p-4">
								<!------------------request form------------------------->
								<div class="partcipate-fund" v-if="transaction_id == '' && !congModuleLev">
									<div class="form-group field-wrapper">
										<account-id></account-id>
									</div>
									
									<div class="form-group field-wrapper dob" v-if="exsisting_leverage != ''">
										<input type="text" v-model="exsisting_leverage"  name="lev" class="float-field "  readonly />
										<label for="password" class="float-label">{{$t('lev_exsistLev')}}</label>
									</div>
									<div class="form-group field-wrapper">
										<select class="mdb-select md-form float-field form-control" v-model="leverage" v-validate="'required'" name="leverage"  :class="(leverage != ''?'active' :'') || ({ 'is-invalid': submitted && errors.has('leverage') })" ref="leverageInput">
											<template v-if="(platform == 'MT5' || parseInt(get_user.pro_user) == 1) && demo_live == '1'">
												<option :value="key"  v-html="key+'X'" v-for="(list,key) in $env_var.leverageJsonNew" v-if=" exsisting_leverage != key"></option>
											</template>
											<template v-else>
												<option :value="key"  v-html="key+'X'" v-for="(list,key) in $env_var.leverageJson" v-if=" exsisting_leverage != key"></option>
											</template>
											
										</select>
										<label for="password" class="float-label">{{$t('lev_newLev')}}</label>
										<ul><li v-for="error in errors.collect('leverage')">{{ error }}</li></ul>
									</div>

									
									<div class="form-group text-center field-wrapper">
										<button class="prism_btn btn_sm" v-on:click.prevent="submitChangeLeverageRequestOtp()">{{$t('lev_changeLeverage')}}</button>
									</div> 
									<div class="signupbtn mt-2 text-center" v-if="come_from_manage_page">
										<router-link :to="'/account'" class="underline">{{$t('lev_backManageAccount')}}</router-link>
									</div>
									<div class="clearfix"></div>
								</div>
								<!----------------------------------------------------->
								<div class="partcipate-fund" v-if="transaction_id != '' && !congModuleLev">
									<div v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 1)">
										<p class="mb-3 text-center">{{$t('rb_googleAuth1')}} <strong>{{$t('rb_googleAuth2')}}</strong> {{$t('rb_googleAuth3')}}. </p>
										<div class="form-group field-wrapper">
											<input type="text" placeholder="000 000" class="mdb-select md-form form-control" v-model="otp" v-validate="{ required: true, max: 6,numeric : true }" name="otp"  :class="{ 'is-invalid': submittedOtp && errors.has('otp') }" ref="otpInput">
											<ul><li v-for="error in errors.collect('otp')">{{ error }}</li></ul>
										</div> 
										<div class="form-group text-center field-wrapper">
											<button class="prism_btn btn_sm " v-on:click.prevent="submitChangeLeverageCheckOtp()">{{$t('rb_validate')}} </button>
										</div>
										<div class="clearfix"></div>
										<div class="d-flex align-items-center justify-content-between border-top pt-3 mt-3"> 
											<div class="desc text-center">
												<p>{{$t('rb_googleAuth4')}} <a v-on:click.prevent="resendLink()" href="#"><strong>{{$t('rb_googleAuth5')}}</strong></a></p>
											</div>
										</div>
										<div class="clearfix"></div>
									</div>
									<div class="middleBox1"  v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 0 && !authComponent)">
										<div class="congratulations">
											<div class="logo_congrats">
												<img src="../../../../static/fxView/images/leverage.svg" alt="Icon">
											</div>
											<div class="subtitle">
												<p class="mb-3">{{$t('verf_dear')}} <strong class="green">{{get_user.username}}</strong>,</p>
												{{$t('rb_googleAuth6')}} <strong>{{get_user.email}}. </strong> {{$t('lev_levMsz1')}}
												<a v-on:click.prevent="resendLink()" href="#" class="mb-3"><strong>{{$t('rb_googleAuth7')}}</strong></a>
											</div>
										</div>
										<div class="clearfix"></div>
										<div class="d-flex align-items-center justify-content-between enble2fa border-top pt-3 mt-3">
											<div class="ico mr-3">
												<img src="../../../../static/fxView/images/google_auth.png" alt="2fa">
											</div>
											<div class="desc w-75">
												<h5 class="mb-2"><strong>{{$t('rb_googleAuth8')}}</strong></h5>
												<p>{{$t('rb_googleAuth9')}} <a v-on:click.prevent="authComponent = true" href="#"><strong>{{$t('rb_googleAuth10')}}</strong></a></p>
											</div>
										</div>
									</div>
								</div>
								<!---------------------congo-message-------------->
								<div class="stepForm" v-if="congModuleLev">
									<div class="congratulations">
										<div class="logo_congrats">
											<img src="../../../../static/fxView/images/check.svg" alt="Icon">
										</div>
										<div class="subtitle">
											<h3>{{$t('rb_congo')}} <span class="green">{{get_user.username}}</span></h3>
											<p>{{$t('lev_levMsz2')}}</p>
											<ul class="includeWdth">
												<li><strong>{{$t('lev_tradingId')}}</strong> {{account_id}}</li>
												<li><strong>{{$t('lev_oldLev')}}</strong>-</li>
												<li><strong>{{$t('lev_newLev')}}</strong>{{leverage}}</li>
											</ul>
										</div>
										<div class="signupbtn full-width submitButton w-100 mt-2 text-center">
											<router-link :to="'/account'" class="prism_btn btn_sm" v-if="$route.name == 'fxView.changeLeverage'">{{$t('lev_goBackMangeAccv')}}</router-link>
											<button class="prism_btn btn_sm" v-on:click.prevent="$parent.tab = 0" v-else>{{$t('lev_goBackMangeAccv')}}</button>
										</div>
									</div> 
								</div>
							</div>
						</div>  
					</div>
				</div>    
			</div>
		</div>
		<div v-else-if="tradingAccountList.totalRecords == 0">
            <div class="mainTitle  text-center my-3">
                <h3>{{$t('lev_noDemoLiveTradingAccFound')}}</h3> 
            </div>
            <no-trading-account :demo_live_both="'b'" :totalRecords = "tradingAccountList.totalRecords"></no-trading-account>
        </div>
		<div v-else class="text-center p-5 customLoader"> 
			<div class="loader"></div>  
            <h4>{{$t('dw_acc_fund_plzWaitWhileProc')}}</h4>
        </div>
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import twoFa from '../users/2FA'
    export default {
        name: 'Change-Leverage', 
        mixins: [fxViewMixins],
        data() {
            return {
				pageName : this.$options.name,
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                //==========================================
                come_from_manage_page : false,
				//-----select account----
                exsisting_leverage : '',
				selectAccount : false,
                account_id : '',
				act_account_id : '',
				demo_live : '',
				platform :'', 
				//------------------------

                leverage : '',
                submitted : false,

                otp : '',
                submittedOtp : false,
                transaction_id : '',

                congModuleLev : false,
                authComponent : false,
                request_page : 'accounts',

            }
        },
        methods:{
            resendLink(){
                let input_json = {
                    'globalParams' : {
                        'trans_id' : this.transaction_id.toString()
                    } ,'localParams' : {'parameter' : this}
                }
                this._runResendEmailLinkAccount(input_json)
            },
            verifyStatus(getstatus){
            	if(getstatus){
            		if(parseInt(getstatus) >= 1){
            			this.$router.push('/pro')
            		}else{
            			this.response_msg =this.$t('lev_waitforVerf')
            			this.msg_type = "error"
            		}

            	}

            },
            //================leverage===================================
            submitChangeLeverageRequestOtp(){
                const _that = this
                this.submitted = true;
                this.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
								'act_account_id': _that.act_account_id,
                                'account_id' : _that.account_id ,
                                "leverage" : _that.leverage,
                                'operation' : 'CHANGE LEVERAGE'
                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runAccountPasswordRequestOtp(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
            submitChangeLeverageCheckOtp(){
                const _that = this
                this.submittedOtp = true;
                this.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                'google_token' : _that.otp.toString() ,
                                'trans_id' : _that.transaction_id.toString()
                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runAccountLeverageCheckOtp(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
            reset(){
                this.account_id = ''
				this.act_account_id = ''
                this.leverage = ''
				this.demo_live = ''
				this.platform = ''
                this.submitted = false
            }
        },
        components: {
            appTwofa: twoFa
        },
        created(){
            if(this.$route.params.account_id){
                this.come_from_manage_page = true
                this.account_id = this.$route.params.account_id
				this.act_account_id = this.$route.params.act_account_id
                this.exsisting_leverage = this.$route.params.leverage
				this.demo_live = this.$route.params.demo_live
				this.platform = this.$route.params.platform
            }
			// this._runGetTradingAccountList({'globalParams' : {} ,'localParams' : {'parameter' : this}})
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/manageAccounts/change_leverage.vue